<template>
  <div :class="preflxCls">
    <z-dialog @close="closeDialog">
      <Row type="flex" justify="center">
        <Col :class="preflxCls + '-left'" span="11">
          <z-upload
            v-if="ossKey && !only && !coverFile"
            v-show="partFiles && partFiles.length < 5"
            :type="10"
            multiple
            @success="successHandle"
            @progress="progressHandle"
            :maxSize="5120"
            :ossKey="ossKey"
            :progressBar="true"
          >
            <div :class="preflxCls + '-left-con'">
              <div v-show="!only" :class="preflxCls + '-left-icon'">
                <i class="iconfont icon-uploadn"></i>
                <p>拖放或单击上传图像</p>
              </div>
            </div>
          </z-upload>
          <div
            v-show="only || coverFile"
            class="zAddProlog-left-con zAddProlog-left-con-only"
          >
            <img
              v-if="!coverFile && partFiles && partFiles.length > 0"
              :src="ossUrl + partFiles[0].key"
              alt
            />
            <img v-if="coverFile" :src="ossUrl + coverFile.key" alt />
          </div>
          <div
            :class="preflxCls + '-left-con'"
            v-if="partFiles && partFiles.length >= 5"
          >
            <div :class="preflxCls + '-left-icon'">
              <i class="iconfont icon-uploadn"></i>
              <p>最多只能传{{ 5 }}张图片</p>
            </div>
          </div>
        </Col>
        <Col :class="preflxCls + '-right'" span="13">
          <div :class="preflxCls + '-right-main'">
            <Tabs v-model="tabName">
              <TabPane
                name="name1"
                :label="coverFile ? '产品编辑' : '产品信息'"
              >
                <Button
                  style="margin-bottom:20px;"
                  :type="showCustom ? 'primary' : 'default'"
                  v-if="coverFile"
                  @click="showCustom = !showCustom"
                  >自定义</Button
                >
                <Form
                  v-show="showCustom"
                  ref="projectFrom"
                  :model="projectFrom || {}"
                  :rules="ruleInProject"
                  label-position="top"
                >
                  <FormItem
                    label="图片:"
                    v-if="
                      partFiles && partFiles.length > 0 && !only && !coverFile
                    "
                  >
                    <Row :gutter="15">
                      <Col
                        span="4"
                        v-for="(item, index) in partFiles"
                        :key="index"
                      >
                        <z-panelimg
                          del
                          :show="false"
                          @delete="deleteHandle(index)"
                          :src="ossUrl + item.key"
                        ></z-panelimg>
                      </Col>
                    </Row>
                  </FormItem>
                  <FormItem prop="name" label="产品名称:">
                    <Input
                      v-model="projectFrom.name"
                      :maxlength="20"
                      placeholder="请输入产品名称"
                    />
                  </FormItem>
                  <FormItem prop="material" label="材质:">
                    <Input
                      v-model="projectFrom.material"
                      placeholder="请输入产品材质"
                    />
                  </FormItem>
                  <FormItem label="尺寸:">
                    <div>
                      <ButtonGroup style="margin-bottom:10px;">
                        <Button
                          @click="changeSizeType(0)"
                          :type="sizeType === 0 ? 'primary' : 'default'"
                          >&nbsp;&nbsp;常规&nbsp;&nbsp;</Button
                        >
                        <Button
                          @click="changeSizeType(1)"
                          :type="sizeType === 1 ? 'primary' : 'default'"
                          >自定义</Button
                        >
                      </ButtonGroup>
                      <Row
                        v-if="sizeType === 1"
                        :gutter="16"
                        type="flex"
                        justify="center"
                        align="middle"
                        style="margin-top:5px;"
                        v-for="(lists, index) in projectFrom.shapeParamSizeList"
                        :key="index"
                      >
                        <Col span="6" v-for="(item, i) in lists" :key="i">
                          <Input
                            v-model="listsValue[index][i][`value${index}_${i}`]"
                            :maxlength="20"
                            :placeholder="item.label + '(mm)'"
                          />
                        </Col>
                        <Col span="6" style="text-align:right">
                          <Button
                            v-if="projectFrom.shapeParamSizeList.length > 1"
                            type="error"
                            size="small"
                            @click="deleteGroup(index)"
                            >删除</Button
                          >
                        </Col>
                      </Row>
                      <Button
                        v-if="
                          projectFrom.shapeParamSizeList &&
                            projectFrom.shapeParamSizeList.length < 10 &&
                            sizeType === 1
                        "
                        style="margin-top:10px;display:block;"
                        @click="addGroup"
                        icon="md-add"
                        >添加</Button
                      >
                    </div>
                  </FormItem>

                  <FormItem label="定制要求:">
                    <Input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 6 }"
                      :maxlength="200"
                      v-model="projectFrom.remark"
                      placeholder="请填写产品备注信息（200字以内）"
                    />
                  </FormItem>
                </Form>

                <proload-space
                  v-if="coverFile"
                  :showCustom="showCustom"
                  :choicedSpec="choicedSpec"
                  :ossUrl="ossUrl"
                  :loading="loading"
                  @submitHandleSpace="submitHandleSpaceHandle"
                  ref="proloadSpace"
                ></proload-space>
              </TabPane>

              <TabPane
                name="name2"
                label="空间选择"
                v-if="areaLists && areaLists.length >= 0"
              >
                <Select v-model="areaId" style="width:400px;margin-top:20px;">
                  <Option
                    v-for="item in areaLists"
                    :value="item.area"
                    :key="item.id"
                    >{{ item.area }}</Option
                  >
                </Select>
              </TabPane>
            </Tabs>
          </div>

          <div
            class="add-proload-btn-bottom"
            :class="['animated', 'fast', 'fadeIn']"
            v-if="!coverFile && display"
            v-show="delary"
          >
            <Button
              v-if="!only"
              size="large"
              type="primary"
              class="red-btn"
              @click="submit('projectFrom')"
              :loading="loading"
              >保存</Button
            >
            <Button
              v-if="only"
              style="margin-right:30px;"
              size="large"
              type="primary"
              @click="submit('projectFrom', 1)"
              :loading="loading"
              >加入项目</Button
            >
            <Button
              v-if="only"
              size="large"
              class="red-btn"
              type="primary"
              @click="submit('projectFrom', 2)"
              :loading="loading"
              >立即询价</Button
            >
          </div>

          <!-- 规格列表切换 -->
          <div
            class="add-proload-btn-bottom"
            :class="['animated', 'fast', 'fadeIn']"
            v-if="coverFile && display"
            v-show="delary"
          >
            <Button
              v-if="!only"
              size="large"
              type="primary"
              class="red-btn"
              @click="spaceHandle"
              :loading="loading"
              >保存</Button
            >
          </div>
        </Col>
      </Row>
    </z-dialog>
  </div>
</template>
<script>
const preflxCls = "zAddProlog";
import { findComponentDownward, randomString } from "../../utils/assist.js";
import ZPanelimg from "../panelimg/panelimg";
import ZDialog from "./dialog";
import ZUpload from "../upload/upload";
import dialogs from "../../mixins/dialogs.js";
import proloadSpace from "./common/proload-space.vue";
export default {
  name: "ZAddProlog",
  mixins: [dialogs],
  provide() {
    return {
      app: this
    };
  },
  data() {
    return {
      preflxCls: preflxCls,
      zAddProlog: preflxCls,
      diaologDom: null,
      partFiles: [],
      sizeType: 0,
      listsValue: [],
      showCustom: true,
      projectFrom: {
        name: "",
        num: 1,
        material: "常规",
        shapeParamSizeList: [],
        remark: ""
      },
      ruleInProject: {
        img: [{ required: true, message: "请上传图片" }],
        name: [{ required: true, message: "请输入产品名称" }],
        material: [{ required: true, message: "请输入材质" }]
      },
      areaId: "",
      delary: false,
      tabName: "name1",
      shapeParamSizeLoading: 0
    };
  },
  props: {
    /* 区域lists */
    areaLists: {
      type: [String, Array],
      default: ""
    },
    /* 当前项目状态 */
    status: {
      type: [Number, String],
      default: ""
    },
    /* 规格传入 */
    choicedSpec: {
      type: Array,
      default: function() {
        return [];
      }
    },
    /* 主图 */
    coverFile: "",
    /* 是否只能上传一张图片 */
    only: {
      type: Boolean,
      default: false
    },
    display: {
      type: Boolean,
      default: false
    },
    localProject: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // oss baseUrl
    ossUrl: {
      type: String,
      default: ""
    },
    // 尺寸 lists
    propSize: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: { ZDialog, ZPanelimg, ZUpload, proloadSpace },

  methods: {
    submit(name, target, set = true) {
      if (
        target !== 3 &&
        set &&
        (!this.partFiles || this.partFiles.length === 0)
      ) {
        this.$Message.warning("请至少上传一张产品图！");
        return false;
      }

      this.$refs[name].validate(valid => {
        if (valid) {
          // 回填
          this.listVlaueToVal();

          if (!this.judjeSizeType()) {
            this.$Message.warning("请完善自定义尺寸");
            return false;
          }

          let product = {
            partFiles: this.partFiles,
            shapeId: this.propSize[0].id || 1
          };
          if (target === 3 && this.coverFile) {
            product.partFiles.push(this.coverFile);
          }
          if (this.sizeType === 0) {
            this.projectFrom.shapeParamSizeList = [];
            product.shapeId = null;
          }
          Object.assign(product, this.projectFrom);
          let obj = {
            area: this.areaId === "未分类" ? "" : this.areaId,
            num: this.projectFrom.num,
            product: product,
            remark: this.projectFrom.remark
          };
          this.$emit("submitHandle", obj, target, set);
        } else {
          this.$Message.warning("填写完整各项！");
        }
      });
    },

    // 数据赋值给value
    listVlaueToVal() {
      if (this.sizeType === 1) {
        let newAry = [];
        this.listsValue.forEach((_list, index) => {
          let _inAry = [];
          _list.forEach((item, i) => {
            let obj = {
              value: item[`value${index}_${i}`],
              key: this.projectFrom.shapeParamSizeList[index][i].key,
              label: this.projectFrom.shapeParamSizeList[index][i].label,
              shapeId: this.projectFrom.shapeParamSizeList[index][i].shapeId,
              shapeParamId: this.projectFrom.shapeParamSizeList[index][i]
                .shapeParamId,
              type: this.projectFrom.shapeParamSizeList[index][i].type
            };
            _inAry.push(obj);
          });
          newAry.push(_inAry);
        });
        this.projectFrom.shapeParamSizeList = newAry;
      } else {
        this.projectFrom.shapeParamSizeList = [];
      }
    },

    judjeSizeType() {
      if (this.sizeType === 1) {
        // 判定是否填写值
        let isNoValue = [];
        this.projectFrom.shapeParamSizeList.forEach(item => {
          const isValue = item.filter(_list => !_list.value)[0];
          isValue && isNoValue.push(isValue);
        });
        if (isNoValue.length === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    changeSizeType(num) {
      this.sizeType = num;
    },
    successHandle(file) {
      if (!file.data[0]) return false;
      if (!this.only) {
        this.partFiles.push(file.data[0]);
      } else {
        let ary = [];
        ary.push(file.data[0]);
        this.partFiles = ary;
      }
      this.shapeParamSizeLoading = 1;
    },
    progressHandle(progress) {
      this.percent = progress;
    },
    deleteHandle(index) {
      this.shapeParamSizeLoading = 1;
      this.partFiles.splice(index, 1);
    },
    addGroup() {
      this.shapeParamSize();
    },
    deleteGroup(index) {
      this.projectFrom.shapeParamSizeList.splice(index, 1);
      this.listsValue.splice(index, 1);
      let newlistsValue = [];
      this.listsValue.forEach((_list, k) => {
        let _newAry = [];
        _list.forEach((item, i) => {
          let _val = `value${k}_${i}`;
          let obj = { [_val]: Object.values(item)[0] };
          _newAry.push(obj);
        });
        newlistsValue.push(_newAry);
      });
      this.listsValue = newlistsValue;
      this.setListsVal();
    },

    closeDialog() {
      this.showCustom = true;
      this.$emit("close");
    },

    // 处理尺寸 lists
    shapeParamSize() {
      if (this.propSize && this.propSize.length === 0) return false;
      if(!this.projectFrom.shapeParamSizeList) {
        this.projectFrom.shapeParamSizeList = [];
      }
      this.projectFrom.shapeParamSizeList.push(this.propSize);
      this.setListsVal();
    },

    // 把尺寸写入listsValue
    setListsVal(target = false) {
      let newlistsValue = [];
      let arry = !target
        ? this.projectFrom.shapeParamSizeList
        : this.localProject.projectFrom.shapeParamSizeList;
      if (arry) {
        arry.length > 0 &&
          arry.forEach((lists, index) => {
            let _newAry = [];
            lists.forEach((item, i) => {
              let obj1 = {},
                obj2 = {};
              let _val = `value${index}_${i}`;
              if (
                this.listsValue.length > 0 &&
                this.listsValue[index] &&
                this.listsValue[index][i][_val]
              ) {
                obj1 = { [_val]: this.listsValue[index][i][_val] };
                _newAry.push(obj1);
              } else {
                obj2 = !target ? { [_val]: "" } : { [_val]: item.value };
                _newAry.push(obj2);
              }
            });
            newlistsValue.push(_newAry);
          });
        this.listsValue = newlistsValue;
      }
    },

    spaceHandle() {
      this.$refs.proloadSpace.submit();
    },

    /* 库产品规格选择 */
    submitHandleSpaceHandle(obj) {
      /* obj === null => 自定义 */
      /* obj === Object => 选择规格 */
      if (!obj) {
        if (this.status !== 0) {
          this.submit("projectFrom", 3);
        } else {
          this.submit("projectFrom", 3, false);
        }
      } else {
        Object.assign(obj, {
          area: this.areaId === "未分类" ? "" : this.areaId
        });
        this.$emit("submitHandleSpace", obj);
      }
    },

    delaryHandle() {
      setTimeout(() => {
        this.delary = true;
      }, 300);
    }

    /* 区域保存 */
    // submit_area() {
    // if(!this.areaId) {
    //   this.$Message.error('')
    //   return false;
    // }

    // this.submit('projectFrom')
    // this.submitHandleSpaceHandle()
    // }
  },

  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  },
  watch: {
    display: function() {
      if (this.display) {
        this.delaryHandle();
        this.tabName = "name1";
        this.diaologDom.op();
      } else {
        this.areaId = "";
        this.delary = false;
        this.diaologDom.close();
        // 重置
        this.$refs["projectFrom"].resetFields();
        this.partFiles = [];
        this.projectFrom.shapeParamSizeList = [];
        this.projectFrom.remark = "";
        this.projectFrom.num = 1;
        this.tabName = "name1";
        this.showCustom = true;
        this.shapeParamSizeLoading = 2;
      }
    },
    propSize: function() {
      this.shapeParamSize();
    },
    "localProject.partFiles": function() {
      if (this.localProject.partFiles) {
        if(!this.areaId) {
          this.areaId = this.localProject.projectFrom.area
        }
        this.projectFrom = this.localProject.projectFrom;
        this.partFiles = this.localProject.partFiles;
        this.setListsVal(true);
        if (
          !this.projectFrom.shapeParamSizeList ||
          this.projectFrom.shapeParamSizeList.length === 0
        ) {
          this.localProject.target ? (this.sizeType = 0) : "";
          this.shapeParamSize();
        } else {
          this.localProject.target ? (this.sizeType = 1) : "";
          // 初始化添加
          // this.shapeParamSizeLoading === 0 && this.shapeParamSize();
        }
      } else {
        this.shapeParamSize();
      }
    },

    coverFile: function() {
      if (this.coverFile) {
        this.showCustom = false;
      }
    },

    areaLists: function() {
      if (!this.areaLists) {
        this.tabName = "name1";
      }
    }
  }
};
</script>
